
const  Telephone = () => {
  // const svgSize = size? size : 45
  // const svgColor = color? "rgb(84 124 164)" : "#fff"
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="45"
          height="45"
          viewBox="0 0 24 24"
        >
          <path fill="#fff" d="M3 4.5v2.007c0 8.008 6.492 14.5 14.5 14.5h2a1.5 1.5 0 001.5-1.5v-2.565a1.5 1.5 0 00-1.026-1.424l-3.183-1.06a1.5 1.5 0 00-1.722.59l-.73 1.094a1.5 1.5 0 01-1.722.59l-1.525-.508a4.932 4.932 0 01-3.198-3.38l-.627-2.3a1.5 1.5 0 01.972-1.817l.603-.201a1.35 1.35 0 00.905-1.503l-.462-2.77A1.5 1.5 0 007.805 3H4.5A1.5 1.5 0 003 4.5zm-1 0A2.5 2.5 0 014.5 2h3.306a2.5 2.5 0 012.466 2.089l.461 2.77a2.35 2.35 0 01-1.575 2.615l-.602.201a.5.5 0 00-.325.606l.627 2.3a3.932 3.932 0 002.55 2.695l1.526.508a.5.5 0 00.574-.197l.729-1.093a2.5 2.5 0 012.87-.985l3.184 1.06A2.5 2.5 0 0122 16.943v2.565a2.5 2.5 0 01-2.5 2.5h-2c-8.56 0-15.5-6.94-15.5-15.5V4.5z"></path>
        </svg>
      );
}

export default Telephone;